var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',_vm._l((_vm.characters),function(character,index){return _c('Footprints',{key:character,attrs:{"footprintsOf":character,"index":index,"hobbits":character === 'frodoSam' || character === 'merryPippin'}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }